"use client";

import React from "react";
import StatsCard from "../../../../components/stats-card";
import Navbar from "../../../../components/navbar";
import Footer from "../../../../components/footer";
import styles from "../css/clinicMenu.module.css";
import { useNavigate } from "react-router-dom";

const statsData = [
  { title: "Booking", icon: "calendar-check-2" }, 
  { title: "Consultation", icon: "stethoscope" },   
  { title: "Consultation History", icon: "hourglass" },   
  { title: "Services", icon: "package" },    
  { title: "DoH Guideline", icon: "file-text" },  
];

export function ClinicMenu() {
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <Navbar />
      <main className={styles.main}>
        <h1 className={styles.title}>Clinic Menu</h1>
        <div className={styles.grid}>
          {statsData.map((stat, index) => (
            <StatsCard
              key={index}
              title={stat.title}
              icon={stat.icon}
              variant="square"
              onClick={
                stat.title === "Booking"
                  ? () => navigate("/customer/clinic/booking")
                  : stat.title === "Consultation"
                  ? () => navigate("/customer/clinic/consultations")
                  : stat.title === "Consultation History"
                  ? () => navigate("/customer/clinic/consultation-history")
                  : stat.title === "Services"
                  ? () => navigate("/customer/clinic/services")
                  : stat.title === "DoH Guideline"
                  ? () => navigate("/customer/clinic/doh-guideline")
                  : undefined
              }
            />
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default ClinicMenu;